export default __webpack_public_path__ + "static/media/medication-fundamental-icon.6fce208a.svg";